module.exports = __webpack_public_path__ + "static/img/Twitter-icon.2890bac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/social/Twitter-icon.png
// module id = ebEl
// module chunks = 0